// Публичный веб-origin приложения — и почему `window.location.origin` им не является.
//
// В браузере (dev и prod) SPA всегда отдаётся с веб-домена, и `origin` верен.
// В Capacitor он равен `capacitor://localhost` / `https://localhost` — адрес
// внутри бандла. Любая ссылка, которая уходит НАРУЖУ (шаринг, `return_to`
// чужого экрана согласия, universal link обратно в приложение), собранная от
// такого origin, ведёт в никуда: чужая сторона либо молча игнорирует адрес не
// на нашем домене (INTEGRATION-GUIDE §1.4, §3.2), либо отдаёт человеку ссылку
// `https://localhost/...`.
//
// Константа продового домена здесь одна на приложение. Второй экземпляр рядом
// с местом использования — ровно тот случай, когда домен однажды поменяется в
// одном файле из двух.
import { IS_CAPACITOR } from "./platform-detect";

/** Каноничный публичный веб-домен StudyHub. */
export const PUBLIC_WEB_ORIGIN = "https://study.iec.exchange";

/**
 * Origin, пригодный для АБСОЛЮТНОЙ внешней ссылки.
 *
 * Web — реальный `window.location.origin` (в dev это `http://localhost:5173`,
 * и подменять его продовым доменом нельзя: сломается локальная проверка).
 * Capacitor — жёстко продовый домен: `capacitor://localhost` наружу не годится.
 */
export function publicWebOrigin(): string {
	if (!IS_CAPACITOR && typeof window !== "undefined" && window.location.origin) {
		return window.location.origin;
	}
	return PUBLIC_WEB_ORIGIN;
}
